/** @jsx jsx */
import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {jsx, css} from '@emotion/react'
import SEO from '../../seo'
import {createMarkup} from '../../../util/datoCmsDataFactory'
import {logDplWithExtensionParams, EVENTS} from '../../../util/dpl'
import onCtaClick from './onCtaClick'

import Header from './header'
import Hero from './hero'
import Section from './section'
import Footer from './footer'
import Bottom from './bottom'

import Review from './review'
import Cta from './cta'

const Advertorial = ({experiment, content, ctaUrl, seo}) => {
    const [hasFiredVisit, setHasFiredVisit] = useState(false)

    useEffect(() => {
        if (!hasFiredVisit) {
            setHasFiredVisit(true)
            localStorage.clear()
            logDplWithExtensionParams(EVENTS.StartpagePageLoad, {
                experiment,
            })
        }
    }, [hasFiredVisit, experiment])

    const [heroData, section1Data, section2Data, section3Data, bottomData] = content.sections

    const {title, description, ogImagePath, ogUrl} = seo

    return (
        <article>
            <SEO title={title} description={description} ogImagePath={ogImagePath} ogUrl={ogUrl} />
            <Header
                onLogoClick={onCtaClick('home', experiment, ctaUrl)}
                onCtaClick={onCtaClick('cta-1', experiment, ctaUrl)}
            />
            <div
                css={css`
                    padding: 0 1rem;
                `}
            >
                <div
                    css={css`
                        max-width: 800px;
                        margin: auto;
                    `}
                >
                    <Hero title={heroData.title} image={heroData.image} />

                    <Section title={section1Data.title} image={section1Data.image} text1={section1Data.text1}>
                        {section1Data.text1 && <div dangerouslySetInnerHTML={createMarkup(section1Data.text1)} />}
                        <Review onClick={onCtaClick('review', experiment, ctaUrl)} />
                        {section1Data.text2 && <div dangerouslySetInnerHTML={createMarkup(section1Data.text2)} />}
                        <Cta onCtaClick={onCtaClick('cta-2', experiment, ctaUrl)} />
                    </Section>

                    <Section title={section2Data.title} image={section2Data.image}>
                        {section2Data.text1 && <div dangerouslySetInnerHTML={createMarkup(section2Data.text1)} />}
                        <Cta onCtaClick={onCtaClick('cta-3', experiment, ctaUrl)} />
                    </Section>

                    <Section title={section3Data.title} image={section3Data.image}>
                        {section3Data.text1 && <div dangerouslySetInnerHTML={createMarkup(section3Data.text1)} />}
                    </Section>
                    <Bottom linksSection={bottomData.text1} onCtaClick={onCtaClick('cta-4', experiment, ctaUrl)} />
                </div>
            </div>
            <Footer />
        </article>
    )
}

Advertorial.propTypes = {
    experiment: PropTypes.string,
    ctaUrl: PropTypes.string,
}

Advertorial.defaultProps = {
    experiment: 'sp-644-advertorial',
    content: {
        sections: Array(5).fill({
            title: ``,
            image: ``,
            text1: ``,
            text2: ``,
        }),
    },
    ctaUrl: `https://www.startpage.com`,
    seo: {
        title: `Startpage`,
        description: `Search In Private`,
        ogImagePath: `https://www.startpage.com/sp/cdn/images/startpage_og_image.png`,
        ogUrl: `https://private.startpage.com`,
    },
}

export default Advertorial
